module.exports = __webpack_public_path__ + "static/media/instrucoes-assinatura.0ab491a2.png";